<script>
import appConfig from "@/app.config";

export default {
  page: {
    title: "",
    meta: [{ name: "description", content: appConfig.description }],
  },
};
</script>
<style>
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  overflow: hidden;
}
body {
  background: linear-gradient(45deg, #00cfff, #2c889f 80%);
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.wrapper {
  width: 90%;
  max-width: 800px;
  padding: 20px;
  text-align: center;
}

h1 {
  font-size: 50px;
  margin-bottom: 0;
  line-height: 1;
  font-weight: 700;
  text-align: center;
  color: #ffffff !important;
  margin-bottom: 10px;
}

h3 {
  text-align: center;
  color: #ffffff !important;
}
p {
  font-size: 17px;
}
</style>
<template>
  <div class="account-pages my-5 pt-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="text-center mb-5">
            <h1>منصة امتنان</h1>
            <h3>استمارة المنح الدراسية في الجمهورية الاسلامية الايرانية</h3>
            <p>
              عزيزي الطالب نود إعلامك بأن التقديم على استمارة منحة الحشد قد تم ايقافه و
              ذلك لنفاد المقاعد المخصصة لهذا العام و سيتم فتح باب التقديم على الاستمارة في
              وقت اخر.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
